package org.lennycodes.hldi.styles
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.focus
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme
val AppInputStyle = CssStyle {
    base {
        Modifier
            .padding(12.px)
            .borderRadius(8.px)
            .border(1.px, LineStyle.Solid, color = Color.rgba(0, 0, 0, 0.2f))
            .fontSize(14.px)
            .width(100.percent)
    }

    focus {
        Modifier
            .outline(0.px)
            .styleModifier {
                property("border-color", HLDITheme.Colors.primary)
                property("box-shadow", "0 0 0 3px rgba(11, 102, 35, 0.1)")
            }
    }
}